export function sortByCdName(a: any, b: any) {
	if (a.Name < b.Name) {
		return -1
	}
	if (a.Name > b.Name) {
		return 1
	}
	return 0
}
